import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';

function BwgButton(props) {
  const { type, onClick, children } = props;
  const antdTypes = ['primary', 'ghost', 'dashed', 'link', 'text', 'default'];
  let antdType = 'default';
  if (antdTypes.includes(type)) {
    antdType = type;
  }

  const htmlTypes = ['button', 'submit', 'reset'];
  let htmlType = 'button';
  if (htmlTypes.includes(type)) {
    htmlType = type;
  }

  const [isLoading, setIsLoading] = useState(false);
  const handleOnClick = async () => {
    try {
      const onClickReturn = onClick();
      if (onClickReturn instanceof Promise) {
        setIsLoading(true);
        await onClickReturn;
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      htmlType={htmlType}
      type={antdType}
      onClick={handleOnClick}
      loading={isLoading}
    >
      {children}
    </Button>
  );
}

BwgButton.propTypes = {
  type: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
};

BwgButton.defaultProps = {
  type: 'default',
  onClick: () => {},
};

export default BwgButton;
